import { supabase } from '../lib/supabase';

export const testSupabaseConnection = async () => {
  try {
    // 测试基本连接
    const { error } = await supabase
      .from('articles')
      .select('count')
      .limit(1);

    if (error) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};

export const testAuth = async () => {
  try {
    // 测试注册功能
    const { error } = await supabase.auth.signUp({
      email: 'test@blog.local',
      password: 'test123456',
      options: {
        data: {
          username: 'testuser'
        }
      }
    });

    if (error) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
}; 